export const mappingPageIdUrls = {
  construction: '/',
  careers: '/careers/',
  contacts: '/contact-us/'
}
